import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-bootstrap';
import { translate } from 'react-i18next';

import './LoginOnlyBySso.scss';
import InnerHtmlContent from '../InnerHtmlContent';

class LoginOnlyBySso extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="login-only-by-sso-container">
        <Grid fluid>
          <Row>
            <Col className="login-only-by-sso">
              <div>
                <InnerHtmlContent content={t('loginOnlyBySso.note')} />
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

LoginOnlyBySso.propTypes = {
  t: PropTypes.func.isRequired
};

LoginOnlyBySso.defaultProps = {
  options: []
};

export default translate(['booking'], { wait: true })(LoginOnlyBySso);



// WEBPACK FOOTER //
// ./src/components/LoginOnlyBySso/LoginOnlyBySso.jsx